import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { Box, CircularProgress, Typography } from "@mui/material";

const Callback = () => {
  const { isLoading } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      // Redirect to dashboard after Auth0 login
      navigate("/", { replace: true });
    }
  }, [isLoading, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <CircularProgress />
      <Typography variant="body1" sx={{ mt: 2 }}>
        Logging in...
      </Typography>
    </Box>
  );
};

export default Callback;
